import React, { useEffect, useRef, useState } from 'react';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

const MsalRedirect: React.FC = () => {
  const broadcastStarted = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (broadcastStarted.current) {
      return;
    }
    broadcastStarted.current = true;

    broadcastResponseToMainFrame().catch((error: Error) => {
      console.error('[FIX] MSAL redirect bridge failed to broadcast response:', error);
      setFailed(true);
    });
  }, []);

  return <p>{failed ? 'Sign-in response could not be delivered. You can close this window and try again.' : 'Processing authentication...'}</p>;
};

export default MsalRedirect;
